import styled from 'styled-components';
import DecimalInputComponent from '@components/form/DecimalInput';

export const Input = styled.input`
  position: absolute;
  top: 0;
  width: 99%;
  height: 100%;
  border: none;
  outline: none;
  text-align: center;
  background: #fafafa;
`;

export const DecimalInput = styled(DecimalInputComponent)`
  position: absolute;
  top: 0;
  width: 99%;
  height: 100%;
  border: none;
  outline: none;
  text-align: center;
  background: #fafafa;
`;